import { RouteConfig } from 'vue-router';
import store from '@/store/index';
import Login from '@/views/Login/index.vue';
import Home from '@/views/Home/index.vue';

const loginRoute = {
  path: '/login',
  name: 'login',
  component: Login,
};

const viewRoutes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: 'dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          name: '首页',
          icon: 'home',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/index/index.vue'),
      },
      {
        path: '/org/operate/:pid',
        name: 'org/operate',
        meta: {
          name: '机构详情',
          icon: 'handshake-o',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/org')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/org/operate/index.vue'),
      },
      {
        path: '/course/chapter/:pid/:type?',
        name: 'course/chapter',
        meta: {
          name: '正式课详情',
          icon: '',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/course')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/course/chapter/index.vue'),
      },
      {
        path: '/exam/detail/:pid/:type?',
        name: 'exam/detail',
        meta: {
          name: '试卷详情',
          icon: '',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/course')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/exams/paper/components/paperDetail.vue'),
      },
      {
        path: '/exam/quesDetail/:pid/:type?',
        name: 'exam/quesDetail',
        meta: {
          name: '题库详情',
          icon: '',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/course')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/exams/questions/components/quesBankDetail.vue'),
      },
      {
        path: '/helpQues/operate/:pid',
        name: 'helpQues/operate',
        meta: {
          name: '问题详情',
          icon: '',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/helpQues')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/helpQues/operate/index.vue'),
      },
      {
        path: '/userManage/myCourse/:pid',
        name: 'userManage/myCourse',
        meta: {
          name: '我的课程',
          icon: '',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/userManage')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/userManage/myCourse/index.vue'),
      },
      {
        path: '/userManage/workManage/:pid',
        name: 'userManage/workManage',
        meta: {
          name: '作品管理',
          icon: '',
          tag: true,
          menu: false,
        },
        beforeEnter: (to, from, next) => {
          if ((store as any).state.user.menuRoutes.map((em: any) => em.path).includes('/userManage')) next();
          else next('/');
        },
        component: () => import('@/views/Home/layout/userManage/workManage/index.vue'),
      },
    ],
  },
];

export {
  loginRoute,
  viewRoutes,
};

export default [
  loginRoute,
];
